import {Customer} from "../../data-access/api-customers/Customer";

export class AuthUtil {
  public static Customer(customer: Customer): Customer {
    return customer.customerEmail
      ? customer
      : Customer.ANONYMOUS
  }
}
